module.exports = __webpack_public_path__ + "img/inno.b67ec065.svg";